// extracted by mini-css-extract-plugin
export default {"mCard":"hC-z","image":"iC-z","imageNoBackground":"jC-z","imageHasCategory":"kC-z","fullWidth":"lC-z"};